import { useEffect, useRef } from 'react';
import { notify } from '../../../utils/notification';
import { spellRecallNotice } from '../../../shared/rules/epicBoons.mjs';

/**
 * Boon of Spell Recall: the server rolls the d4 as the slot is spent, whichever spell path spent it, and the slot profile
 * every path sends back carries the result. Each roll is announced once.
 */
export default function useSpellRecallNotice({ form }) {
  const recall = form?.spellSlotProfile?.spellRecall;
  const seen = useRef(null);
  useEffect(() => {
    if (!recall?.id || seen.current === recall.id) return;
    seen.current = recall.id;
    notify(spellRecallNotice(recall), recall.slotKept ? 'success' : 'info');
  }, [recall]);
}
